import { Goal } from './Goal';

export const kind = 'Disable';

export type Disable = Goal<typeof kind>;
